module.exports = __webpack_public_path__ + "staticcomp/img/more_articles_bottom.9a12db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/more_articles_bottom.png
// module id = Wxjv
// module chunks = 39